import React, { useEffect, useState } from 'react';
import { Container, Box, Typography } from '@mui/material';
import ApiService from '../../services/api';

const CookiesPolicy = () => {
  const lastUpdated = 'November 2025';
  const [systemSettings, setSystemSettings] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const settings = await ApiService.getSystemSettings();
        if (!mounted) return;
        setSystemSettings(settings || null);
        try { localStorage.setItem('systemSettings', JSON.stringify(settings)); } catch (_) {}
        try { localStorage.setItem('adminSettings', JSON.stringify(settings)); } catch (_) {}
      } catch (_) {
        try {
          const raw = localStorage.getItem('systemSettings') || localStorage.getItem('adminSettings');
          const parsed = raw ? JSON.parse(raw) : null;
          if (mounted) setSystemSettings(parsed);
        } catch (_) {}
      }
    })();
    // Listen for admin settings updates to refresh content live
    const onSettingsUpdated = (e) => {
      const detail = e?.detail || null;
      if (detail && mounted) {
        setSystemSettings(detail);
      } else {
        // Fallback: try localStorage if available
        try {
          const raw = localStorage.getItem('adminSettings');
          if (raw && mounted) setSystemSettings(JSON.parse(raw));
        } catch (_) {}
      }
    };
    try { window.addEventListener('systemSettingsUpdated', onSettingsUpdated); } catch (_) {}
    return () => { mounted = false; };
  }, []);

  const adminCookies = (systemSettings?.legal?.cookiesPolicy || '').trim();

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Box>
        <Typography variant="h3" gutterBottom>
          Cookies Policy
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Last updated: {lastUpdated}
        </Typography>

        {adminCookies ? (
          <Typography paragraph sx={{ whiteSpace: 'pre-wrap' }}>
            {adminCookies}
          </Typography>
        ) : (
          <>
            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
              What Are Cookies?
            </Typography>
            <Typography paragraph>
              Cookies are small text files placed on your device to help the site function, provide analytics, remember preferences, and support security.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
              Types of Cookies We Use
            </Typography>
            <ul>
              <li>
                <Typography component="span" paragraph>
                  Strictly necessary: required for core features like authentication and session management.
                </Typography>
              </li>
              <li>
                <Typography component="span" paragraph>
                  Preferences: remember choices such as language and time format.
                </Typography>
              </li>
              <li>
                <Typography component="span" paragraph>
                  Analytics: help us understand usage and improve the platform.
                </Typography>
              </li>
              <li>
                <Typography component="span" paragraph>
                  Security/anti‑fraud: assist with rate‑limiting and prevention of abusive behavior.
                </Typography>
              </li>
            </ul>

            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
              Managing Cookies
            </Typography>
            <Typography paragraph>
              You can control cookies through your browser settings. Disabling certain cookies may impact functionality.
            </Typography>
          </>
        )}
      </Box>
    </Container>
  );
};

export default CookiesPolicy;